import { render, staticRenderFns } from "./EditEndorsementPrintTemplate.vue?vue&type=template&id=18c91c9a&scoped=true"
import script from "./EditEndorsementPrintTemplate.vue?vue&type=script&lang=ts"
export * from "./EditEndorsementPrintTemplate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c91c9a",
  null
  
)

export default component.exports